import { InsuranceProvider, partnerInsuranceSchema } from '../types.js';
export function mapFragmentToProps({ partnerInsurance: partnerInsuranceField, insurance: insuranceField, }) {
    const insurance = mapFieldsToInsurance({
        insurance: insuranceField,
        partnerInsurance: partnerInsuranceField,
    });
    if (!insurance) {
        return null;
    }
    const insuranceGroups = mapToInsuranceGroups(insurance);
    if (insuranceGroups.length === 0) {
        return null;
    }
    return { insuranceGroups, provider: insurance.provider };
}
function mapToInsuranceGroups(insurance) {
    if (!insurance) {
        return [];
    }
    const insuranceProducts = insurance.packages.flatMap(insurancePackage => insurancePackage.products);
    return insuranceProducts.reduce((groups, insuranceProduct) => {
        var _a;
        const groupId = generateGroupIdForInsuranceProduct(insuranceProduct);
        const group = groups.find(group => group.id === groupId);
        if (group) {
            group.products.push(insuranceProduct);
            return groups;
        }
        groups.push({
            id: groupId,
            paymentType: insuranceProduct.paymentType,
            insuranceType: insuranceProduct.insuranceType,
            durationInYears: (_a = insuranceProduct.durationInYears) !== null && _a !== void 0 ? _a : 1,
            products: [insuranceProduct],
        });
        return groups;
    }, []);
}
function generateGroupIdForInsuranceProduct({ paymentType, durationInYears }) {
    if (paymentType === 'monthly') {
        return 'monthly';
    }
    return `${paymentType}-${durationInYears}`;
}
function mapFieldsToInsurance({ partnerInsurance, insurance, }) {
    if (insurance) {
        return mapInsurance(insurance);
    }
    if (partnerInsurance) {
        return mapPartnerInsurance(partnerInsurance);
    }
    return null;
}
export function mapPartnerInsurance(partnerInsurance) {
    const { success, data } = partnerInsuranceSchema.safeParse(partnerInsurance);
    if (!success) {
        return null;
    }
    const products = data.insuranceQuotes
        .map(mapInsuranceQuote)
        .sort((a, b) => a.premium.includingVat - b.premium.includingVat);
    return {
        packages: [{ products }],
        provider: InsuranceProvider.CoverGenius,
    };
}
function mapInsurance(insurance) {
    if (isInsuranceDataValid(insurance)) {
        return {
            ...filterInsuranceAttributes(insurance),
            provider: InsuranceProvider.ERGO,
        };
    }
    return null;
}
function isInsuranceDataValid(insurance) {
    const insuranceProducts = insurance.packages.flatMap(insurancePackage => insurancePackage.products);
    if (insuranceProducts.length === 0)
        return false;
    const hasDataMissing = insuranceProducts.some(product => product.isRecommended === null ||
        product.durationInYears === null ||
        product.attributes.some(attribute => attribute.name === null));
    return !hasDataMissing;
}
function filterInsuranceAttributes(insurance) {
    const excludedInsuranceAttributesIds = ['10001', '10002', '10003', '10004'];
    return {
        ...insurance,
        packages: insurance.packages.map(insurancePackage => ({
            ...insurancePackage,
            products: insurancePackage.products.map(product => ({
                ...product,
                attributes: product.attributes.filter(attribute => !excludedInsuranceAttributesIds.includes(attribute.id)),
            })),
        })),
    };
}
function mapInsuranceQuote(insuranceQuote) {
    const salesPrice = getSalesPrice(insuranceQuote);
    return {
        id: String(insuranceQuote.insuranceProductId),
        quoteId: insuranceQuote.insuranceQuoteId,
        title: insuranceQuote.title,
        paymentType: insuranceQuote.paymentType,
        insuranceType: insuranceQuote.insuranceType,
        // TODO: [XSELL-3222] Get real data for "isRecommended" field
        isRecommended: false,
        durationInYears: insuranceQuote.durationInYears,
        attributes: insuranceQuote.inclusions.map((inclusion, index) => ({
            id: index.toString(),
            name: inclusion.title,
        })),
        premium: salesPrice,
        yearlyPremium: insuranceQuote.premiums.yearly,
        salesPrice,
    };
}
function getSalesPrice(insuranceQuote) {
    switch (insuranceQuote.paymentType) {
        case 'MONTHLY':
            return {
                includingVat: insuranceQuote.premiums.recurring.includingVat,
            };
        case 'ONE_TIME':
            return {
                includingVat: insuranceQuote.premiums.oneTime.includingVat,
            };
    }
}
//# sourceMappingURL=mapFragmentToProps.js.map